import { useState, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { supabase } from '../config/supabase'

const VIPRoute = ({ children }) => {
  const { user } = useAuth()
  const [isAuthorized, setIsAuthorized] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const checkAccess = async () => {
      if (!user) {
        setLoading(false)
        return
      }

      try {
        const { data, error } = await supabase
          .from('profiles')
          .select('membership')
          .eq('id', user.id)
          .single()

        if (error) throw error
        // อนุญาตให้ admin, vip และ lifetime เข้าถึงได้
        setIsAuthorized(['admin', 'vip', 'lifetime'].includes(data.membership))
      } catch (error) {
        console.error('Error checking access status:', error)
      } finally {
        setLoading(false)
      }
    }

    checkAccess()
  }, [user])

  if (loading) {
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center">
        <div className="text-xl">กำลังโหลด...</div>
      </div>
    )
  }

  if (!user || !isAuthorized) {
    return <Navigate to="/vip" />
  }

  return children
}

export default VIPRoute
